export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_MENU = "SET_MENU";
export const SET_AUTH_ERROR = "SET_AUTH_ERROR";
export const SET_VERIFY_DATA = "SET_VERIFY_DATA";
export const SET_ACCESS_DENIED = "SET_ACCESS_DENIED";
export const SET_ACCESS_DENIED_MESSAGE = "SET_ACCESS_DENIED_MESSAGE";
export const SET_SHOW_WARNING_SAVE = "SET_SHOW_WARNING_SAVE";
